"use client"

import { useState } from "react"
import { Link } from "react-router-dom"
import "./Navbar.css"

const Navbar = ({ language, toggleLanguage }) => {
  const [isOpen, setIsOpen] = useState(false)

  const navItems = {
    en: [
      { label: "Home", path: "/" },
      { label: "About AKY", path: "/about" },
      { label: "Projects", path: "/projects" },
      { label: "Awards", path: "/awards" },
      { label: "How to Vote", path: "/how-to-vote" },
      { label: "Polling Units", path: "/polling-units" },
      { label: "Snapshots", path: "/snapshots" },
      { label: "FAQ", path: "/faq" },
      { label: "Contact Us", path: "/contacts" },
      
    ],
    ha: [
      { label: "Gida", path: "/" },
      { label: "Game da AKY", path: "/about" },
      { label: "Ayyuka", path: "/projects" },
      { label: "Lambobin Yabo", path: "/awards" },
      { label: "Yadda Ake Zabe", path: "/how-to-vote" },
      { label: "Injin Zabe", path: "/polling-units" },
      { label: "Hotuna", path: "/snapshots" },
      { label: "Tambayoyi", path: "/faq" },
      { label: "Tuntube Mu", path: "/contacts" },
    ],
  }

  const currentNavItems = navItems[language]

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={() => setIsOpen(false)}>
          <span className="logo-text">AKY</span>
        </Link>

        {/* Hamburger Icon */}
        <div className={`hamburger ${isOpen ? "open" : ""}`} onClick={() => setIsOpen(!isOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Full mobile dropdown menu */}
        <ul className={`nav-menu ${isOpen ? "active" : ""}`}>
          {currentNavItems.map((item) => (
            <li key={item.path} className="nav-item">
              <Link
                to={item.path}
                className="nav-link"
                onClick={() => setIsOpen(false)}
              >
                {item.label}
              </Link>
            </li>
          ))}

          {/* Language button inside mobile menu */}
          <li className="nav-item">
            <button
              className="language-toggle"
              onClick={() => {
                toggleLanguage()
                setIsOpen(false)
              }}
            >
              {language === "en" ? "HA" : "EN"}
            </button>
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default Navbar
